export function unwrapDateValue(
  date: string | { date: string } | null | undefined,
): string {
  if (!date) {
    return "";
  }
  return typeof date === "object" ? date.date : date;
}

export function verboseDatetimeFormat(
  dateStringified: string | { date: string },
) {
  if (!dateStringified) {
    return "";
  }

  const dateValue =
    typeof dateStringified === "object"
      ? dateStringified.date
      : dateStringified;

  const date = new Date(dateValue);

  if (isNaN(date.getTime())) {
    return "";
  }

  const actualYear = new Date().getFullYear();
  const articleYear = date.getFullYear();
  const yearDifference = actualYear - articleYear;

  const mapMonths: Record<string, string> = {
    "01": "stycznia",
    "02": "lutego",
    "03": "marca",
    "04": "kwietnia",
    "05": "maja",
    "06": "czerwca",
    "07": "lipca",
    "08": "sierpnia",
    "09": "września",
    "10": "października",
    "11": "listopada",
    "12": "grudnia",
  };

  const month = String(date.getMonth() + 1).padStart(2, "0");

  if (actualYear + 1 === articleYear) {
    return date.getDate() + " " + mapMonths[month] + " " + articleYear;
  }

  if (actualYear === articleYear) {
    return date.getDate() + " " + mapMonths[month];
  } else if (yearDifference === 1) {
    if (Number(month) > new Date().getMonth() + 1) {
      return date.getDate() + " " + mapMonths[month] + " " + articleYear;
    }
    return "Rok temu";
  } else if (yearDifference < 5) {
    return yearDifference + " lata temu";
  } else {
    return yearDifference + " lat temu";
  }
}
